import axios from "axios";
import qs from "qs";

export const apiClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  withCredentials: true // Necesario para que el navegador envíe/reciba la cookie _vt (visitor throttle)
});

/**
 * Interceptor de respuesta que detecta cuando el backend pide reCAPTCHA (403 + require_recaptcha).
 * Automáticamente ejecuta grecaptcha.execute(), obtiene un token, y reintenta el request original.
 * El usuario no nota nada — todo pasa en segundo plano.
 */
apiClient.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    var originalRequest = error.config;

    // Si el backend responde 403 con require_recaptcha y no es un retry
    if (
      error.response &&
      error.response.status === 403 &&
      error.response.data &&
      error.response.data.require_recaptcha &&
      !originalRequest._isRetry
    ) {
      originalRequest._isRetry = true;

      // Ejecutar reCAPTCHA v3 invisible y reintentar el request con el token
      if (window.grecaptcha && window.grecaptcha.execute) {
        return new Promise(function (resolve, reject) {
          window.grecaptcha.ready(function () {
            window.grecaptcha.execute(process.env.VUE_APP_RECAPTCHA_SITE_KEY, { action: 'visitor_verify' })
              .then(function (token) {
                // Agregar el token al header y reintentar
                originalRequest.headers['X-Recaptcha-Token'] = token;
                resolve(apiClient(originalRequest));
              })
              .catch(function (err) {
                reject(err);
              });
          });
        });
      }
    }

    return Promise.reject(error);
  }
);

export default {
  login(user) {
    return apiClient.post("/login", user);
  },
  logout(user) {
    return apiClient.post("/logout", user);
  },
  get(payload) {
    if (payload.data) {
      return apiClient.get(payload.url, {params:payload.data});
    }else {
      return apiClient.get(payload.url);
    }
  },
  post(payload) {
    return apiClient.post(payload.url, qs.stringify(payload.data));
  },
  put(payload) {
    return apiClient.put(payload.url, qs.stringify(payload.data));
  },
  delete(payload) {
    return apiClient.delete(payload.url);
  },
  getFile(data, modo = 'descargar') {
    const id = typeof data === 'object' ? data.id : data;
    return apiClient.get("edicto/" + id + "/file", { params: { modo: modo } });
  },
  getPdf(payload) {
    return apiClient.get(payload.url, {
      params: payload.data,
      responseType: "arraybuffer"
    });
  },
  postJSON(payload) {
    return apiClient.post(payload.url, payload.data);
  }
};
